webpackJsonp([55828127892833],{

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _config = __webpack_require__(10);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _PageTitle = __webpack_require__(22);
	
	var _PageTitle2 = _interopRequireDefault(_PageTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RSVP = function RSVP() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_PageTitle2.default, { title: 'Livestream' }),
	    _config2.default.live.formHTML
	  );
	};
	
	exports.default = RSVP;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-live-js-4b86de85236434461602.js